import { detect } from 'detect-browser';
import semver from 'semver';

export default function updateBrowser(config = {
  chrome: '71.0.0',
  safari: '12.0.0',
  ie: '10.0.0',
  firefox: '64.0.0',
}) {
  const browser = detect();
  const updateAlert = document.querySelector('.alert--update-browser');
  const browsers = {
    chrome: 'chrome',
    safari: 'safari',
    firefox: 'firefox',
    ie: 'ie',
  };
  if (browser.name === browsers.chrome && semver.lt(browser.version, config.chrome)) {
    updateAlert.style.display = 'block';
  }

  if (browser.name === browsers.safari && semver.lt(browser.version, config.safari)) {
    updateAlert.style.display = 'block';
  }

  if (browser.name === browsers.firefox && semver.lt(browser.version, config.firefox)) {
    updateAlert.style.display = 'block';
  }

  if (browser.name === browsers.ie && semver.lt(browser.version, config.ie)) {
    updateAlert.style.display = 'block';
  }
}



// WEBPACK FOOTER //
// ./js/components/updateBrowser/updateBrowser.js